import { compose } from 'lodash/fp'
import withForm from 'utils/withForm'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { renameProp } from 'recompose'

const AddNewOrganization = gql`
  mutation AddNewOrganization($organization: OrganizationInput) {
    addOrganization(organization: $organization) {
      id
    }
  }
`

export default compose(
  graphql(AddNewOrganization),
  withForm({
    initialValues: {
      name: ''
    },
    validator: x => ({}),
    onSuccess: (props, values) => {
      return props.mutate({ variables: { organization: values } })
    }
  }),
  renameProp('save', 'saveNewOrganization')
)


// WEBPACK FOOTER //
// ./src/modules/organizations/withNewOrganization.js